import * as React from 'react';

const CardPercent = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.1667 17.5C11.8658 17.5 10 15.6341 10 13.3333C10 11.0325 11.8658 9.16663 14.1667 9.16663C16.4683 9.16663 18.3333 11.0325 18.3333 13.3333C18.3333 15.6341 16.4683 17.5 14.1667 17.5Z"
      stroke="#00AFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.708 14.7917L15.6247 11.875"
      stroke="#00AFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1.6665 5.70837H17.4998" stroke="#00AFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17.4998 10.8333V4.16667C17.4998 3.24583 16.754 2.5 15.8332 2.5H3.33317C2.41234 2.5 1.6665 3.24583 1.6665 4.16667V11.6667C1.6665 12.5875 2.41234 13.3333 3.33317 13.3333H9.99984"
      stroke="#00AFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12.7082" cy="11.875" r="0.791667" fill="#00AFFF" />
    <ellipse cx="15.6247" cy="14.7917" rx="0.791667" ry="0.791667" fill="#00AFFF" />
  </svg>
));

export default CardPercent;
